import React, {useState, useEffect} from 'react';
import {useSelector} from "react-redux";

const BookingFile = ({file, width=750, height=900}) => {
    const [loading, setLoading] = useState(true);
    const [blobUrl, setBlobUrl] = useState(null);
    const [error, setError] = useState(null);
    const idToken = useSelector(state => state.auth.idToken);
    const isImage = file.fileName.match(/\.(jpeg|jpg|gif|png|webp)$/i);

    useEffect(() => {
        const headers = new Headers();
        headers.append('Authorization', idToken);

        fetch(file.url, {headers})
            .then(response => {
                if (!response.ok) throw new Error('Failed to load file');
                return response.blob();
            })
            .then(blob => {
                setBlobUrl(URL.createObjectURL(blob));
                setLoading(false);
            })
            .catch(() => {
                setError('Failed to load file');
                setLoading(false);
            });

        return () => {
            if (blobUrl) URL.revokeObjectURL(blobUrl);
        };
    }, [file.url, idToken]);

    if (error) {
        return <div style={{ width: '100%', textAlign: 'center' }}><h3 className="py-4">{error}</h3></div>;
    }

    return (
        <div style={{ width: '100%', height: '100%', textAlign: 'center' }}>
            {loading && <h3 className="py-4">Loading file...</h3>}
            {blobUrl && isImage && (
                <img
                    src={blobUrl}
                    alt="File preview"
                    style={{ maxWidth: '100%', height: 'auto', maxHeight: '100%' }}
                />
            )}
            {blobUrl && !isImage && (
                <iframe
                    src={blobUrl}
                    style={{ width: '100%', height: '100%', border: 'none' }}
                />
            )}
        </div>
    )
}

export default BookingFile;